'use client';
import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { spaceProp } from '../../mixins/spaceProp.js';
import { ListItemBaseLi } from './ListItemBase.js';
import { getListVariantStyles } from './mixins/getListVariantStyles.js';

const StyledList = styled.ul.withConfig({
  componentId: "sc-10cs3p3-0"
})(["display:flex;flex-direction:column;width:auto;margin:0;padding:0;margin-bottom:", ";", " ", ";outline:none;", "{&:last-child,&:last-of-type{margin:0;}}"], ({
  theme
}) => theme.components.list.marginBottom, ({
  spaceAfter
}) => spaceProp(spaceAfter), ({
  variant = 'vertical-start',
  isBordered,
  spaceBetween
}) => getListVariantStyles(variant, spaceBetween, isBordered), ListItemBaseLi);
const List = /*#__PURE__*/withTitan((_a, ref) => {
  var {
      spaceAfter,
      spaceBetween,
      children,
      className,
      type,
      variant = 'vertical-start',
      testId = 'list',
      isBordered
    } = _a,
    rest = __rest(_a, ["spaceAfter", "spaceBetween", "children", "className", "type", "variant", "testId", "isBordered"]);
  return jsx(StyledList, Object.assign({
    ref: ref,
    as: type,
    className: className,
    "data-test-id": testId,
    isBordered: isBordered,
    spaceAfter: spaceAfter,
    spaceBetween: spaceBetween,
    variant: variant
  }, rest, {
    children: children
  }));
}, {
  name: 'List',
  memo: true
});

export { List };
//# sourceMappingURL=List.js.map
